import React, { useRef, useEffect } from 'react';
import classNames from 'classnames';
import moment from 'moment';

import { Trans } from '@fec/assets/js/utils/trans';

import './LivetickerItem.scss';

const formatDate = (date) => {
  let prefix = '';
  let momentDate = moment.parseZone(date);
  let dateString = momentDate.format('HH:mm');
  const businessUnit = document.querySelector('body').getAttribute('data-bu');
  const suffix = businessUnit.toLowerCase() === 'rtr' ? '' : ' Uhr';

  if (
    !moment().isSame(momentDate, 'day') &&
    moment().add(-1, 'days').isSame(momentDate, 'day')
  ) {
    // yesterday
    prefix = new Trans().getGlobal('i18n:date:yesterday') + ', ';
  } else if (!moment().isSame(momentDate, 'day')) {
    // all other days except today (and yesterday)
    dateString = momentDate.format('DD.MM.YY, HH:mm');
  }
  return `${prefix}${dateString}${suffix}`;
};

const formatISODate = (date) => moment(date).format();

const LivetickerItem = ({
  date,
  title = false,
  withMedia = false,
  isFocussed = false,
  children,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (isFocussed && ref.current) {
      ref.current.focus({
        preventScroll: true,
      });
    }
  }, [isFocussed]);

  return (
    <li
      ref={ref}
      /* make item focusable, so we can .focus() on it after pressing the Show-more-button */
      tabIndex="0"
      className={classNames('liveticker-item', {
        'ticker-media': withMedia,
      })}>
      <time className="liveticker-item__time" dateTime={formatISODate(date)}>
        {formatDate(date)}
      </time>
      {title && <h3 className="liveticker-item__title">{title}</h3>}
      {children}
    </li>
  );
};

export default LivetickerItem;
